import React from "react"; 
import {ORDERSEARCH_PAGE,PRODUCTION_PATH} from "../../AppConfig";
import OrderHeader from  './OrderHeader';
import PolicyFooter from './../Common/PolicyFooter';
import OrderItemListing from './OrderItemListing';
import { fetchContactMechData } from '../../redux/actions/orderAction'

import { connect } from 'react-redux'; 

class OrderDetailPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            orderItemDetails: {},
            orderInfo: [],
            storeId : window.sessionStorage.getItem('storeId')
        } 
    }

    componentWillMount() {    
        // redirect to the Order Search page when the user directly comes to the Order Detail page
      if(this.props.orderDetails==null){
        let orderSearchUrl = PRODUCTION_PATH + this.state.storeId + ORDERSEARCH_PAGE;
        this.props.history.push(orderSearchUrl);    
      }
       else if ( Object.entries(this.props.orderDetails).length < 1) {          
            let orderSearchUrl = PRODUCTION_PATH + this.state.storeId  + ORDERSEARCH_PAGE;
            this.props.history.push(orderSearchUrl); 
        }   
        
    }
     
    render() {
        let orderListings = []

        for(const returnLabelSetting of Object.keys(this.props.orderDetails.items)) {
            const facilities = this.props.orderDetails.items[returnLabelSetting];
            for(const facilityId of Object.keys(facilities)) {
                const contactMechIds = facilities[facilityId]
                for(const contactMechId of Object.keys(contactMechIds)) {
                    const items = contactMechIds[contactMechId]
                    orderListings.push(<OrderItemListing 
                                        facilityId={facilityId}
                                        items={items}
                                        orderMap={this.props.orderDetails.orderMap}
                                        returnResponses={this.props.orderDetails.returnResponses}
                                        billInfoMap={this.props.orderDetails.billInfoMap}
                                        returnLabelSetting={returnLabelSetting}
                                        contactInfo={fetchContactMechData({facilityId: facilityId, contactMechId: contactMechId})}
                    />)
                }
            }
        }

        return (
                <React.Fragment>

                    {/*<h3>Instructions for returning:</h3>
                    {this.props.returnInstructions ? (
                        <div dangerouslySetInnerHTML={{ __html: this.props.returnInstructions }}></div>
                    ) : (
                        <ul>
                            <li>Please ship these items to the address listed above.</li>
                            <li>Print out this returns slip and include it with your package.</li>
                            <li>Ship the package via USPS, FedEx, or UPS (we suggest getting a tracking number).</li>
                        </ul>
                    )}*/}

                    <OrderHeader props={this.props} />

                    {orderListings.map(orderListing => {return (
                        <div className="row">
                            {orderListing}
                        </div>
                    )})}

                    <PolicyFooter/>

                </React.Fragment>
        );

    }
}
 
const mapStateToProps = (state) => ({ 
    orderDetails: state.orderDataDetails.orderData,
    returnInstructions: state.storeSettingData.storeDesign.returnSettingsMap.returnInstructions,
    policyData: state.storeSettingData.storeDesign, 
});

export default connect(mapStateToProps, {})(OrderDetailPage); 



// WEBPACK FOOTER //
// ./src/components/OrderDetails/OrderDetailPage.js